/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import OneStopListPage from 'domain/gpo/oneStop/List';
import OneStopCreatePage from 'domain/gpo/oneStop/Create';
import { ProtectedRouter } from 'infrastructure/routing';
import { Navigate, Route, Router } from 'framework/routing';
import { useOneStopRoute } from 'domain/shared/oneStop';
import { GlobalProtectedRoute } from 'framework/authorization';
import { ONE_STOP_PATH, ONE_STOP_ROOT_PATH } from 'domain/shared/oneStop';

export const EMPLOYEE_READ_ONE_STOP = 'EMPLOYEE_READ_ONE_STOP';

const OneStopRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useOneStopRoute();

  return (
    <ProtectedRouter basePath={ONE_STOP_PATH}>
      <Routes>
        <Route path="" element={<Navigate to={ONE_STOP_PATH} replace />} />

        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={EMPLOYEE_READ_ONE_STOP}>
              <OneStopListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={EMPLOYEE_READ_ONE_STOP}>
              <OneStopCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

OneStopRouter.getRouterPath = () => `${ONE_STOP_ROOT_PATH}/*`;

export default OneStopRouter;
